var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object',{staticClass:"frame",style:(_vm.frameStyle),attrs:{"data":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }